import { UwvDecision } from '@/resources/models/uwv-decisions';

import NewUwvDecision from '@/views/constants/uwv-decision-new';
import UwvDecisions from '@/views/constants/uwv-decisions';
import Validator from '@/views/validations/uwv-decision-new';
import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';

const state = {
  newUwvDecision: new UwvDecision()
};

const getters = {
  newUwvDecision: state => state.newUwvDecision,

  newUwvDecisionRequiredFields: state => Validator.requiredFields(state.newUwvDecision),
  newUwvDecisionValidations: state => Validator.validate(state.newUwvDecision)
};

const actions = {
  [NewUwvDecision.Actions.Form.CHANGE] ({ commit }, data) {
    commit(NewUwvDecision.Mutations.Form.CHANGE, data);
  },

  [NewUwvDecision.Actions.Cancel.DO] ({ commit }) {
    commit(NewUwvDecision.Mutations.CLEAR);
  },

  [UwvDecisions.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'NewUwvDecision') {
      commit(NewUwvDecision.Mutations.CLEAR);
    }
  },

  [UwvDecisions.Actions.Tabs.New.OPEN] ({ commit }, data) {
    commit(NewUwvDecision.Mutations.INITIALIZE, data);
  },

  [ReportsOfSicknessResource.Actions.UwvDecision.Create.SUCCESS] ({ commit }) {
    commit(NewUwvDecision.Mutations.CLEAR);
  }
};

const mutations = {
  [NewUwvDecision.Mutations.CLEAR] (state) {
    state.newUwvDecision = new UwvDecision();
  },

  [NewUwvDecision.Mutations.INITIALIZE] (state, payload) {
    state.newUwvDecision = new UwvDecision({
      employeeCustomerNumber: payload.employee.id,
      reportOfSicknessId: payload.reportOfSickness.id
    });
  },

  [NewUwvDecision.Mutations.Form.CHANGE] (state, payload) {
    state.newUwvDecision[payload.attribute] = payload.value;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
